<template>
  <div>
    <el-input
      v-if="editable"
      v-model="inputValue"
      v-bind="{
        ...propOptions
      }"
    >
    </el-input>
    <div v-else :class="$style.htmlDiv" v-html="value"></div>
  </div>
</template>
<script>
export default {
  props: {
    value: [ String, Number ],
    form: Object,
    editable: {
      type: Boolean,
      default: true
    },
    propOptions: Object,
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" module>
.htmlDiv {
  white-space: pre-line;
}
</style>
